export const baseApiUrl = process.env.VUE_APP_API_URL || "http://localhost:3001"
